import React from 'react'
import { LazyLoadComponent } from 'react-lazy-load-image-component'

class InternalEmbeddedVideo extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      supported: document.createElement('video').canPlayType(props.type)
    }
  }

  render () {
    const handleError = () => {
      this.setState({ supported: '' })
    }

    return (
      <div>
        {this.state.supported
          ? <video
            className="max-w-xl mx-auto w-full object-contain object-top py-4"
            autoPlay
            playsInline
            muted
            loop
            onError={handleError}
          >
            <source src={this.props.path} type={this.props.type} />
          </video>
          : <img
            src={this.props.fallBackImgPath}
            alt=""
          />
        }
      </div>
    )
  }
}

const EmbeddedVideo = props => {
  return (
    <LazyLoadComponent
      threshold={250}
    >
      <InternalEmbeddedVideo {...props} />
    </LazyLoadComponent>
  )
}

export default EmbeddedVideo
